export default function StaticDataGetter($http) {
    'ngInject';

    const FLIGHTS_CABIN_CLASSES_URL = '/staticdata/GetCabinClasses';
    const TRAINS_CABIN_CLASSES_URL = '/staticdata/GetEurostarCabinClasses';
    const AIRLINES_URL = '/staticdata/GetAirlines';
    const DATE_RANGES_URL = '/staticdata/GetDateRanges';
    const FARE_TYPES_URL = '/staticdata/GetFareTypes';

    return {
        getAirlines,
        getFlightsCabinClasses,
        getTrainsCabinClasses,
        getFareTypes,
        getTimeSlots,
    };

    function getFlightsCabinClasses() {
        return $http.apiGET(FLIGHTS_CABIN_CLASSES_URL, {cache: true})
                .then(({data}) => data);
    }

    function getTrainsCabinClasses() {
        return $http.apiGET(TRAINS_CABIN_CLASSES_URL, {cache: true})
            .then(({data}) => data);
    }

    function getAirlines(name) {
        const params = {name};
        return $http.apiGET(AIRLINES_URL, {params, cache: true, noSpinner: true})
            .then(({data}) => data);
    }

    function getTimeSlots() {
        return $http.apiGET(DATE_RANGES_URL, {
            noSpinner: true,
            cache: true,
        }).then(({data}) => data);
    }

    function getFareTypes() {
        return $http.apiGET(FARE_TYPES_URL, {
            noSpinner: true,
            cache: true,
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/services/static-data-getter.js